var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.4996L7.5 9.99956M10 12.4996C11.164 12.0568 12.2807 11.4985 13.3333 10.8329M10 12.4996V16.6662C10 16.6662 12.525 16.2079 13.3333 14.9996C14.2333 13.6496 13.3333 10.8329 13.3333 10.8329M7.5 9.99956C7.94345 8.84908 8.50184 7.74627 9.16667 6.70789C10.1377 5.15538 11.4897 3.8771 13.0942 2.99463C14.6986 2.11217 16.5022 1.65486 18.3333 1.66622C18.3333 3.93289 17.6833 7.91622 13.3333 10.8329M7.5 9.99956H3.33333C3.33333 9.99956 3.79167 7.47456 5 6.66622C6.35 5.76622 9.16667 6.66622 9.16667 6.66622M3.75 13.7496C2.5 14.7996 2.08333 17.9162 2.08333 17.9162C2.08333 17.9162 5.2 17.4996 6.25 16.2496C6.84167 15.5496 6.83333 14.4746 6.175 13.8246C5.85109 13.5154 5.42441 13.3368 4.97686 13.3229C4.5293 13.3091 4.0924 13.461 3.75 13.7496Z",
    stroke: "currentColor",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.f87676c7482662e3edb13131558809d0.svg";
export { ForwardRef as ReactComponent };